module.exports = __webpack_public_path__ + "img/alarmMap.900cd1ae.svg";